import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ModalComponent } from '../../components/modal/modal.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { UniversityService } from '../../services/university.service';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { ButtonComponent } from '../../components/button/button.component';
import { ToggleTabsComponent } from '../../components/toggle-tabs/toggle-tabs.component';
import { EvaluationService } from '../../services/evaluation.service';

@Component({
  selector: 'app-re-evaluations-list-page',
  imports: [HeaderComponent, CommonModule, ModalComponent, PluralPipe, AgGridListComponent, SelectInputComponent, SearchInputComponent, ButtonComponent, ToggleTabsComponent],
  templateUrl: './re-evaluations-list-page.component.html',
})
export class ReEvaluationsListPageComponent {
  page_name = 'Re-evaluations';
  params: any = {};
  selected_ids: any = {}
  items: any
  isLoading: boolean = false

  tabList = [
    { name: 'All', action: () => this.filter('All') },
    { name: 'Pending', action: () => this.filter('Pending') },
    { name: 'In Progress', action: () => this.filter('In Progress') },
    { name: 'Completed', action: () => this.filter('Completed') },
  ];

  current_status: string = 'All';

  filter(type: string) {
    this.current_status = type;
    const filters: any = {
      page: '1',
      page_size: '50'
    };

    if (type !== 'All') {
      filters.status = type === 'In Progress' ? 'in_progress' : type.toLowerCase();
    }

    this.get_list(filters);
  }

  re_evaluations_cols: any = [
    { headerName: 'Sr.No', field: 'SrNo', flex: 1 },
    { field: 'application_date', headerName: 'Application Date', minWidth: 150, flex: 1 },
    { field: 'academic_year', headerName: 'Academic Year', minWidth: 140, flex: 1 },
    { field: 'university', headerName: 'School', minWidth: 150, flex: 1 },
    { field: 'program', headerName: 'Program', minWidth: 130, flex: 1 },
    { field: 'stream', headerName: 'Stream', minWidth: 130, flex: 1 },
    { field: 'exam_name', headerName: 'Exam Name (Code)', minWidth: 160, flex: 1 },
    { field: 'subject', headerName: 'Subject (Code)', minWidth: 150, flex: 1 },
    { field: 'total_marks', headerName: 'Total Marks', minWidth: 140, flex: 1 },
    { field: 'marks_obtained', headerName: 'Marks Obtained', minWidth: 150, flex: 1 },
    { field: 're_evaluated_marks', headerName: 'Re-Evaluated Marks', minWidth: 170, flex: 1 },
    { field: 'status', headerName: 'Status', minWidth: 120, flex: 1 },
  ];

  actions(row: any) {
    let actions: any = []
    // actions.push({ text: 'Download Receipt', shortcut: 'u', color: 'grey', icon: 'bx  bx-arrow-to-bottom', function: this.download_receipt.bind(this) })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public us: UniversityService, public ar: ActivatedRoute, public es: EvaluationService) { }

  async ngOnInit() {
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      // Only call get_list if there are query params with filters
      const filters: any = { page: '1', page_size: '50' };
      if (params.status) {
        filters.status = params.status;
      }
      this.get_list(filters);
    })
  }

  async get_list(filter?: any) {
    if (this.isLoading) return; // Prevent duplicate calls

    try {
      this.isLoading = true;
      const filters = filter || { page: '1', page_size: '50' };

      const response = await this.es.get_re_evaluation_list(filters);

      if (response?.data) {
        // Transform the data to match the grid columns
        this.items = {
          ...response,
          data: response.data.map((item: any, index: number) => ({
            id: item.id,
            SrNo: ((parseInt(filters.page) - 1) * parseInt(filters.page_size)) + index + 1,
            application_date: new Date(item.requested_at).toLocaleDateString('en-GB'),
            academic_year: item.script?.Assessment?.exam?.academic_year || '-',
            university: item.script?.Assessment?.university?.name || '-',
            program: item.script?.Assessment?.program?.name || '-',
            stream: item.script?.Assessment?.stream?.name || '-',
            exam_name: `${item.script?.Assessment?.exam?.name || '-'} (${item.script?.Assessment?.exam?.code || '-'})`,
            subject: `${item.script?.Assessment?.subject?.name || '-'} (${item.script?.Assessment?.subject?.code || '-'})`,
            total_marks: item.script?.Assessment?.total_marks || '-',
            marks_obtained: item.script?.marks_obtained || '-',
            re_evaluated_marks: item.total_marks || '-',
            status: item.status.charAt(0).toUpperCase() + item.status.slice(1),
            raw_data: item
          }))
        };
      }
    } catch (error: any) {
      console.error('Error fetching re-evaluation list:', error);
      this.gs.toastr_shows_function(error?.message || 'Failed to fetch re-evaluation list', 'Error', 'error');
    } finally {
      this.isLoading = false;
    }
  }

  async download_receipt(item: any, index: any) {
    this.selected_ids = item;
    console.log(this.selected_ids, "  this.selected_ids");

  }

}
